import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const RefreshableLink = ({ to, label }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <button
            onClick={() => (isActive ? (window.location.href = to) : navigate(to))}
            className={`${isActive ? "text-blue-400 underline" : "hover:text-gray-300"}`}
        >
            {label}
        </button>
    );
};



